import { useState } from 'react'
import { monthGrid, isoKey, WEEKDAY_HEADERS } from '../lib/date'

/** タップで日付をトグル選択する月カレンダー */
export default function Calendar({
  selected,
  onToggle,
}: {
  selected: Set<string>
  onToggle: (key: string) => void
}) {
  const today = new Date()
  const [year, setYear] = useState(today.getFullYear())
  const [month0, setMonth0] = useState(today.getMonth())
  const todayKey = isoKey(today)

  const prev = () => {
    if (month0 === 0) {
      setYear(year - 1)
      setMonth0(11)
    } else setMonth0(month0 - 1)
  }
  const next = () => {
    if (month0 === 11) {
      setYear(year + 1)
      setMonth0(0)
    } else setMonth0(month0 + 1)
  }

  const weeks = monthGrid(year, month0)
  const navBtn =
    'flex h-9 w-9 items-center justify-center rounded-lg text-muted transition hover:bg-brand-soft hover:text-brand-ink active:scale-90'

  return (
    <div className="rounded-2xl border border-line bg-white p-2.5">
      <div className="mb-1.5 flex items-center justify-between px-1">
        <button type="button" onClick={prev} className={navBtn} aria-label="前の月">
          ‹
        </button>
        <span className="font-display text-base font-bold text-ink">
          {year}年{month0 + 1}月
        </span>
        <button type="button" onClick={next} className={navBtn} aria-label="次の月">
          ›
        </button>
      </div>

      <div className="grid grid-cols-7 text-center text-sm font-semibold text-muted">
        {WEEKDAY_HEADERS.map((w, i) => (
          <div key={w} className={`py-1 ${i === 0 ? 'text-conflict/70' : i === 6 ? 'text-brand/70' : ''}`}>
            {w}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {weeks.flat().map((d, i) => {
          if (!d) return <div key={i} />
          const key = isoKey(d)
          const isSelected = selected.has(key)
          const isToday = key === todayKey
          return (
            <button
              key={i}
              type="button"
              onClick={() => onToggle(key)}
              className={`font-display flex h-12 items-center justify-center rounded-xl text-base font-medium transition active:scale-90 ${
                isSelected
                  ? 'bg-brand text-white shadow-[0_4px_12px_-4px_rgba(77,85,217,0.6)]'
                  : isToday
                    ? 'bg-teal-soft text-teal ring-1 ring-teal/30 hover:bg-brand-soft'
                    : 'text-ink hover:bg-brand-soft'
              }`}
            >
              {d.getDate()}
            </button>
          )
        })}
      </div>
    </div>
  )
}
